import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cui-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss']
})
export class CuiBackgroundComponent implements OnInit {

  @Input()
  productLogoSrc: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/background/background.component.ts